import React, {useContext} from "react";
import {SingleSKU} from "./SingleSKU";
import {isEcommerceEnabled} from "../../../../../selectors/generic";
import {MultiSKU} from "./MultiSKU";
import {ProductContext} from "../../../../pages/ProductStencil";

export const Sku = ({enabled}) => {
    const {Packaging} = useContext(ProductContext);

    if(!isEcommerceEnabled() || !Packaging.length ) {return null}

    return (
        <>
            {Packaging.length > 1 ? <MultiSKU enabled={enabled}/> : <SingleSKU enabled={enabled}/>}
        </>)
}

